import React, { useEffect, useState, Component } from 'react';
import Layout from '../../components/Layout';
import { useNavigate } from 'react-router-dom';
import { GraduationCapIcon, SearchIcon, FilterIcon, ChevronDownIcon, ChevronRightIcon, HeartIcon, ClockIcon, CalendarIcon, TrendingUpIcon, BriefcaseIcon, CheckCircleIcon, SparklesIcon, ListIcon, GridIcon, XIcon, BrainIcon, BookOpenIcon, BuildingIcon, ArrowDownIcon, ArrowUpIcon, SlidersIcon } from 'lucide-react';
// Sample program data
const samplePrograms = [{
  id: 'PRG001',
  name: 'Master of Business Administration',
  university: 'UAE Business School',
  type: "Master's",
  duration: '2 Years',
  matchScore: 95,
  skills: ['Leadership', 'Strategic Management', 'Finance'],
  tags: ['In-Demand', 'High Salary'],
  deadline: 'March 15, 2024',
  location: 'Dubai',
  tuition: '$30,000',
  language: 'English'
}, {
  id: 'PRG002',
  name: 'Bachelor of Computer Science',
  university: 'UAE Technology Institute',
  type: "Bachelor's",
  duration: '4 Years',
  matchScore: 88,
  skills: ['Programming', 'Data Structures', 'Algorithms'],
  tags: ['High Completion', 'In-Demand'],
  deadline: 'April 30, 2024',
  location: 'Abu Dhabi',
  tuition: '$25,000',
  language: 'English'
}, {
  id: 'PRG003',
  name: 'Diploma in Digital Marketing',
  university: 'UAE Business School',
  type: 'Diploma',
  duration: '1 Year',
  matchScore: 82,
  skills: ['Social Media Marketing', 'SEO', 'Content Strategy'],
  tags: ['Fast Completion', 'Flexible Schedule'],
  deadline: 'May 20, 2024',
  location: 'Dubai',
  tuition: '$15,000',
  language: 'English'
}, {
  id: 'PRG004',
  name: 'PhD in Data Science',
  university: 'UAE Research University',
  type: 'Doctorate',
  duration: '3 Years',
  matchScore: 91,
  skills: ['Machine Learning', 'Big Data', 'Statistics'],
  tags: ['Research Focused', 'High Salary'],
  deadline: 'June 15, 2024',
  location: 'Sharjah',
  tuition: '$40,000',
  language: 'English'
}, {
  id: 'PRG005',
  name: 'Master of Public Administration',
  university: 'UAE Government Institute',
  type: "Master's",
  duration: '2 Years',
  matchScore: 79,
  skills: ['Policy Analysis', 'Public Management', 'Governance'],
  tags: ['Government Sector', 'Leadership'],
  deadline: 'July 10, 2024',
  location: 'Abu Dhabi',
  tuition: '$28,000',
  language: 'English & Arabic'
}, {
  id: 'PRG006',
  name: 'Bachelor of Business Administration',
  university: 'UAE Business School',
  type: "Bachelor's",
  duration: '4 Years',
  matchScore: 85,
  skills: ['Management', 'Accounting', 'Marketing'],
  tags: ['High Completion', 'Flexible Schedule'],
  deadline: 'August 5, 2024',
  location: 'Dubai',
  tuition: '$24,000',
  language: 'English'
}, {
  id: 'PRG007',
  name: 'Master of Engineering',
  university: 'UAE Technology Institute',
  type: "Master's",
  duration: '2 Years',
  matchScore: 87,
  skills: ['Engineering Design', 'Project Management', 'Innovation'],
  tags: ['In-Demand', 'High Salary'],
  deadline: 'September 1, 2024',
  location: 'Abu Dhabi',
  tuition: '$32,000',
  language: 'English'
}, {
  id: 'PRG008',
  name: 'Bachelor of Arts in Media',
  university: 'UAE Creative Arts College',
  type: "Bachelor's",
  duration: '3 Years',
  matchScore: 76,
  skills: ['Media Production', 'Communication', 'Digital Media'],
  tags: ['Creative', 'Practical'],
  deadline: 'September 30, 2024',
  location: 'Dubai',
  tuition: '$22,000',
  language: 'English'
}];
// Filter options
const filterOptions = {
  degreeTypes: ['All Types', "Bachelor's", "Master's", 'Doctorate', 'Diploma', 'Certificate'],
  durations: ['All Durations', '1 Year', '2 Years', '3 Years', '4 Years', '5+ Years'],
  institutions: ['All Institutions', 'UAE Business School', 'UAE Technology Institute', 'UAE Research University', 'UAE Government Institute', 'UAE Creative Arts College'],
  tags: ['All Tags', 'In-Demand', 'High Salary', 'Fast Completion', 'Flexible Schedule', 'Research Focused', 'Government Sector', 'Leadership', 'Creative', 'Practical', 'High Completion'],
  matchLevels: ['All Matches', 'Excellent (90%+)', 'Great (80-89%)', 'Good (70-79%)', 'Fair (Below 70%)']
};
// Program Card Component
const ProgramCard = ({
  program,
  onSave,
  isSaved
}) => {
  const navigate = useNavigate();
  const getTagIcon = tag => {
    switch (tag) {
      case 'In-Demand':
        return <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-4316" />;
      case 'High Salary':
        return <BriefcaseIcon className="w-3 h-3 mr-1" data-id="element-4317" />;
      case 'High Completion':
        return <CheckCircleIcon className="w-3 h-3 mr-1" data-id="element-4318" />;
      case 'Fast Completion':
        return <ClockIcon className="w-3 h-3 mr-1" data-id="element-4319" />;
      case 'Flexible Schedule':
        return <CalendarIcon className="w-3 h-3 mr-1" data-id="element-4320" />;
      case 'Research Focused':
        return <BookOpenIcon className="w-3 h-3 mr-1" data-id="element-4321" />;
      case 'Government Sector':
        return <BuildingIcon className="w-3 h-3 mr-1" data-id="element-4322" />;
      default:
        return <SparklesIcon className="w-3 h-3 mr-1" data-id="element-4323" />;
    }
  };
  const handleCardClick = () => {
    // Navigate to program details page
    navigate(`/student/programs/${program.id}`);
  };
  const handleSaveToggle = e => {
    e.stopPropagation(); // Prevent card click when clicking the heart
    onSave(program.id);
  };
  return <div className="bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all overflow-hidden cursor-pointer" onClick={handleCardClick} data-id="element-4324">
      {program.matchScore && <div className="bg-primary-500 text-white text-xs font-medium px-3 py-1.5 flex items-center" data-id="element-4325">
          <div className="relative inline-flex items-center cursor-pointer group" data-id="element-4326">
            <div className="hover:opacity-90 transition-opacity flex items-center" data-id="element-4327">
              <SparklesIcon className="w-3 h-3 mr-1.5" data-id="element-4328" />
              {program.matchScore}% Match
            </div>
            <div className="invisible group-hover:visible absolute bottom-full left-0 mb-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 p-3 text-sm z-[100] transform -translate-x-1/4" data-id="element-4329">
              <div className="flex items-start" data-id="element-4330">
                <div className="text-left" data-id="element-4331">
                  <h4 className="font-medium text-gray-900 mb-1" data-id="element-4332">
                    Why This Program Matches Your Profile
                  </h4>
                  <p className="text-gray-700 text-xs" data-id="element-4333">
                    {program.matchScore >= 90 ? `This program is an excellent match for your profile! Your background in ${program.skills[0]} and interest in ${program.skills[1] || program.skills[0]} aligns perfectly with this program's curriculum.` : program.matchScore >= 80 ? `This program is a great match for your profile. Your skills in ${program.skills[0]} complement this program's focus on ${program.tags[0]}.` : program.matchScore >= 70 ? `This program is a good match for your profile. Your interest in ${program.skills[0]} aligns with this program's offerings.` : `This program matches some aspects of your profile, particularly your interest in ${program.skills[0]}.`}
                    {program.tags.includes('High Salary') && ' This program can lead to high-paying career opportunities.'}
                    {program.tags.includes('In-Demand') && ' Graduates of this program are in high demand in the job market.'}
                    {program.tags.includes('Fast Completion') && ' You can complete this program relatively quickly.'}
                    {program.tags.includes('Flexible Schedule') && ' The program offers flexibility that matches your preferences.'}
                  </p>
                </div>
              </div>
              <div className="absolute bottom-0 left-8 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white border-r border-b border-gray-200" data-id="element-4334"></div>
            </div>
          </div>
        </div>}
      <div className="p-5" data-id="element-4335">
        <div className="flex justify-between items-start mb-3" data-id="element-4336">
          <div data-id="element-4337">
            <h3 className="text-lg font-medium text-gray-800" data-id="element-4338">
              {program.name}
            </h3>
            <p className="text-sm text-gray-600 mt-1" data-id="element-4339">{program.university}</p>
          </div>
          <button onClick={handleSaveToggle} className="text-gray-400 hover:text-red-500 transition-colors p-1" aria-label={isSaved ? 'Unsave program' : 'Save program'} data-id="element-4340">
            <HeartIcon className={`w-5 h-5 ${isSaved ? 'fill-red-500 text-red-500' : ''}`} data-id="element-4341" />
          </button>
        </div>
        <div className="flex items-center mb-4 text-sm text-gray-600" data-id="element-4342">
          <GraduationCapIcon className="w-4 h-4 mr-1.5" data-id="element-4343" />
          <span className="mr-4" data-id="element-4344">{program.type}</span>
          <ClockIcon className="w-4 h-4 mr-1.5" data-id="element-4345" />
          <span data-id="element-4346">{program.duration}</span>
        </div>
        <div className="mb-4" data-id="element-4347">
          <div className="flex flex-wrap gap-1.5 mb-3" data-id="element-4348">
            {program.skills.map((skill, index) => <span key={index} className="bg-gray-50 text-gray-700 text-xs px-2.5 py-1 rounded-full" data-id="element-4349">
                {skill}
              </span>)}
          </div>
          <div className="flex flex-wrap gap-1.5" data-id="element-4350">
            {program.tags.map((tag, index) => <span key={index} className="bg-primary-50 text-primary-700 text-xs px-2.5 py-1 rounded-full flex items-center" data-id="element-4351">
                {getTagIcon(tag)}
                {tag}
              </span>)}
          </div>
        </div>
        <div className="flex items-center justify-between mt-4 text-sm" data-id="element-4352">
          <div className="text-gray-600" data-id="element-4353">
            <CalendarIcon className="w-4 h-4 inline mr-1.5" data-id="element-4354" />
            Deadline: {program.deadline}
          </div>
          <div className="flex space-x-2" data-id="element-4355">
            <button onClick={e => {
            e.stopPropagation(); // Prevent card click when clicking apply
          }} className="px-3 py-1.5 bg-primary-500 text-white text-xs font-medium rounded-md hover:bg-primary-600 transition-colors" data-id="element-4356">
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </div>;
};
// Program Table Row Component
const ProgramTableRow = ({
  program,
  onSave,
  isSaved
}) => {
  const navigate = useNavigate();
  const handleViewDetails = () => {
    navigate(`/student/programs/${program.id}`);
  };
  const handleSaveToggle = e => {
    e.stopPropagation();
    onSave(program.id);
  };
  return <tr className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={handleViewDetails} data-id="element-4357">
      <td className="px-4 py-3" data-id="element-4358">
        <div className="flex items-start" data-id="element-4359">
          <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary-50 flex items-center justify-center" data-id="element-4360">
            <GraduationCapIcon className="h-5 w-5 text-primary-500" data-id="element-4361" />
          </div>
          <div className="ml-3" data-id="element-4362">
            <div className="text-sm font-medium text-gray-900" data-id="element-4363">
              {program.name}
            </div>
            <div className="text-xs text-gray-500" data-id="element-4364">{program.university}</div>
          </div>
        </div>
      </td>
      <td className="px-4 py-3" data-id="element-4365">
        <div className="text-sm text-gray-900" data-id="element-4366">{program.type}</div>
        <div className="text-xs text-gray-500" data-id="element-4367">{program.duration}</div>
      </td>
      <td className="px-4 py-3" data-id="element-4368">
        <div className="text-sm text-gray-900" data-id="element-4369">{program.location}</div>
        <div className="text-xs text-gray-500" data-id="element-4370">{program.language}</div>
      </td>
      <td className="px-4 py-3" data-id="element-4371">
        <div className="text-sm text-gray-900" data-id="element-4372">{program.deadline}</div>
      </td>
      <td className="px-4 py-3" data-id="element-4373">
        {program.matchScore && <div className="flex items-center" data-id="element-4374">
            <div className="relative inline-flex items-center cursor-pointer group" data-id="element-4375">
              <div className="hover:opacity-90 transition-opacity flex items-center" data-id="element-4376">
                <div className="w-10 h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-4377">
                  <div className="h-full bg-primary-500" style={{
                width: `${program.matchScore}%`
              }} data-id="element-4378"></div>
                </div>
                <span className="ml-2 text-sm font-medium text-primary-600" data-id="element-4379">
                  {program.matchScore}%
                </span>
              </div>
              <div className="invisible group-hover:visible absolute bottom-full left-0 mb-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 p-3 text-sm z-[100] transform -translate-x-1/4" data-id="element-4380">
                <div className="flex items-start" data-id="element-4381">
                  <div className="text-left" data-id="element-4382">
                    <h4 className="font-medium text-gray-900 mb-1" data-id="element-4383">
                      Why This Program Matches Your Profile
                    </h4>
                    <p className="text-gray-700 text-xs" data-id="element-4384">
                      {program.matchScore >= 90 ? `This program is an excellent match for your profile! Your background in ${program.skills[0]} and interest in ${program.skills[1] || program.skills[0]} aligns perfectly with this program's curriculum.` : program.matchScore >= 80 ? `This program is a great match for your profile. Your skills in ${program.skills[0]} complement this program's focus on ${program.tags[0]}.` : program.matchScore >= 70 ? `This program is a good match for your profile. Your interest in ${program.skills[0]} aligns with this program's offerings.` : `This program matches some aspects of your profile, particularly your interest in ${program.skills[0]}.`}
                      {program.tags.includes('High Salary') && ' This program can lead to high-paying career opportunities.'}
                      {program.tags.includes('In-Demand') && ' Graduates of this program are in high demand in the job market.'}
                      {program.tags.includes('Fast Completion') && ' You can complete this program relatively quickly.'}
                      {program.tags.includes('Flexible Schedule') && ' The program offers flexibility that matches your preferences.'}
                    </p>
                  </div>
                </div>
                <div className="absolute bottom-0 left-8 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white border-r border-b border-gray-200" data-id="element-4385"></div>
              </div>
            </div>
          </div>}
      </td>
      <td className="px-4 py-3 text-right" data-id="element-4386">
        <div className="flex items-center justify-end space-x-2" data-id="element-4387">
          <button onClick={handleSaveToggle} className="p-1.5 rounded-full hover:bg-gray-100" aria-label={isSaved ? 'Unsave program' : 'Save program'} data-id="element-4388">
            <HeartIcon className={`w-4 h-4 ${isSaved ? 'fill-red-500 text-red-500' : 'text-gray-400'}`} data-id="element-4389" />
          </button>
          <button className="px-3 py-1.5 bg-primary-500 text-white text-xs font-medium rounded-md hover:bg-primary-600 transition-colors" data-id="element-4390">
            Apply
          </button>
        </div>
      </td>
    </tr>;
};
// Filters Component
const ProgramFilters = ({
  filters,
  setFilters,
  isOpen,
  onClose
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const handleFilterChange = (category, value) => {
    setLocalFilters({
      ...localFilters,
      [category]: value
    });
  };
  const handleApplyFilters = () => {
    setFilters(localFilters);
    if (onClose) onClose();
  };
  const handleResetFilters = () => {
    const resetFilters = {
      degreeType: 'All Types',
      duration: 'All Durations',
      institution: 'All Institutions',
      tags: 'All Tags',
      matchLevel: 'All Matches'
    };
    setLocalFilters(resetFilters);
    setFilters(resetFilters);
    if (onClose) onClose();
  };
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm p-5 ${isOpen ? 'block' : ''}`} data-id="element-4391">
      <div className="flex justify-between items-center mb-4" data-id="element-4392">
        <h3 className="text-base font-medium text-gray-800 flex items-center" data-id="element-4393">
          <FilterIcon className="w-4 h-4 mr-2" data-id="element-4394" />
          Filters
        </h3>
        {onClose && <button onClick={onClose} className="text-gray-500 hover:text-gray-700 p-1" data-id="element-4395">
            <XIcon className="w-5 h-5" data-id="element-4396" />
          </button>}
      </div>
      <div className="space-y-5" data-id="element-4397">
        {/* Degree Type Filter */}
        <div data-id="element-4398">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4399">
            Degree Type
          </label>
          <select value={localFilters.degreeType} onChange={e => handleFilterChange('degreeType', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4400">
            {filterOptions.degreeTypes.map(type => <option key={type} value={type} data-id="element-4401">
                {type}
              </option>)}
          </select>
        </div>
        {/* Duration Filter */}
        <div data-id="element-4402">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4403">
            Program Duration
          </label>
          <select value={localFilters.duration} onChange={e => handleFilterChange('duration', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4404">
            {filterOptions.durations.map(duration => <option key={duration} value={duration} data-id="element-4405">
                {duration}
              </option>)}
          </select>
        </div>
        {/* Institution Filter */}
        <div data-id="element-4406">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4407">
            Institution
          </label>
          <select value={localFilters.institution} onChange={e => handleFilterChange('institution', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4408">
            {filterOptions.institutions.map(institution => <option key={institution} value={institution} data-id="element-4409">
                {institution}
              </option>)}
          </select>
        </div>
        {/* Tags Filter */}
        <div data-id="element-4410">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4411">
            Tags
          </label>
          <select value={localFilters.tags} onChange={e => handleFilterChange('tags', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4412">
            {filterOptions.tags.map(tag => <option key={tag} value={tag} data-id="element-4413">
                {tag}
              </option>)}
          </select>
        </div>
        {/* Match Level Filter */}
        <div data-id="element-4414">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4415">
            AI Match Level
          </label>
          <select value={localFilters.matchLevel} onChange={e => handleFilterChange('matchLevel', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4416">
            {filterOptions.matchLevels.map(level => <option key={level} value={level} data-id="element-4417">
                {level}
              </option>)}
          </select>
        </div>
        {/* Action Buttons */}
        <div className="flex gap-3 pt-2" data-id="element-4418">
          <button onClick={handleResetFilters} className="flex-1 px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-4419">
            Reset
          </button>
          <button onClick={handleApplyFilters} className="flex-1 px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors" data-id="element-4420">
            Apply Filters
          </button>
        </div>
      </div>
    </div>;
};
// Quick Filter Chip
const FilterChip = ({
  label,
  isActive,
  onClick
}) => <button onClick={onClick} className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${isActive ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-4421">
    {label}
  </button>;
// Empty State Component
const EmptyState = ({
  onReset,
  onAiSuggestions
}) => <div className="text-center py-12 px-4" data-id="element-4422">
    <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-4423">
      <GraduationCapIcon className="w-8 h-8 text-gray-400" data-id="element-4424" />
    </div>
    <h3 className="text-gray-700 font-medium text-lg mb-2" data-id="element-4425">
      No programs match your filters
    </h3>
    <p className="text-gray-500 max-w-md mx-auto mb-6" data-id="element-4426">
      Try adjusting your search criteria or resetting filters to see more
      programs.
    </p>
    <div className="flex flex-col sm:flex-row justify-center gap-3" data-id="element-4427">
      <button onClick={onReset} className="px-5 py-2.5 bg-white text-gray-700 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-4428">
        Reset Filters
      </button>
      <button onClick={onAiSuggestions} className="px-5 py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors flex items-center justify-center" data-id="element-4429">
        <BrainIcon className="w-4 h-4 mr-2" data-id="element-4430" />
        Get AI Recommendations
      </button>
    </div>
  </div>;
// Main Explore Programs Component
const ExplorePrograms = () => {
  const navigate = useNavigate();
  const [view, setView] = useState('card');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('relevance');
  const [sortDirection, setSortDirection] = useState('desc');
  const [savedPrograms, setSavedPrograms] = useState([]);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  // Filter state
  const [filters, setFilters] = useState({
    degreeType: 'All Types',
    duration: 'All Durations',
    institution: 'All Institutions',
    tags: 'All Tags',
    matchLevel: 'All Matches'
  });
  // Quick filter state
  const [quickFilter, setQuickFilter] = useState('All');
  // Toggle save/unsave program
  const toggleSaveProgram = programId => {
    if (savedPrograms.includes(programId)) {
      setSavedPrograms(savedPrograms.filter(id => id !== programId));
    } else {
      setSavedPrograms([...savedPrograms, programId]);
    }
  };
  // Handle sort change
  const handleSortChange = e => {
    setSortBy(e.target.value);
  };
  // Toggle sort direction
  const toggleSortDirection = () => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };
  // Filter programs based on search, filters, etc.
  const filteredPrograms = samplePrograms.filter(program => {
    // Search query filter
    const matchesSearch = searchQuery === '' || program.name.toLowerCase().includes(searchQuery.toLowerCase()) || program.university.toLowerCase().includes(searchQuery.toLowerCase());
    // Degree type filter
    const matchesDegreeType = filters.degreeType === 'All Types' || program.type === filters.degreeType;
    // Duration filter
    const matchesDuration = filters.duration === 'All Durations' || program.duration === filters.duration;
    // Institution filter
    const matchesInstitution = filters.institution === 'All Institutions' || program.university === filters.institution;
    // Tags filter
    const matchesTags = filters.tags === 'All Tags' || program.tags.includes(filters.tags);
    // Match level filter
    const matchesMatchLevel = filters.matchLevel === 'All Matches';
    if (filters.matchLevel === 'Excellent (90%+)') {
      return matchesSearch && matchesDegreeType && matchesDuration && matchesInstitution && matchesTags && program.matchScore >= 90;
    } else if (filters.matchLevel === 'Great (80-89%)') {
      return matchesSearch && matchesDegreeType && matchesDuration && matchesInstitution && matchesTags && program.matchScore >= 80 && program.matchScore < 90;
    } else if (filters.matchLevel === 'Good (70-79%)') {
      return matchesSearch && matchesDegreeType && matchesDuration && matchesInstitution && matchesTags && program.matchScore >= 70 && program.matchScore < 80;
    } else if (filters.matchLevel === 'Fair (Below 70%)') {
      return matchesSearch && matchesDegreeType && matchesDuration && matchesInstitution && matchesTags && program.matchScore < 70;
    }
    return matchesSearch && matchesDegreeType && matchesDuration && matchesInstitution && matchesTags && matchesMatchLevel;
  });
  // Apply quick filter
  const quickFilteredPrograms = quickFilter === 'All' ? filteredPrograms : filteredPrograms.filter(program => program.type === quickFilter);
  // Get recommended programs (top matches)
  const recommendedPrograms = [...samplePrograms].sort((a, b) => b.matchScore - a.matchScore).slice(0, 3);
  // Sort programs
  const sortedPrograms = [...quickFilteredPrograms].sort((a, b) => {
    if (sortBy === 'relevance') {
      return sortDirection === 'desc' ? b.matchScore - a.matchScore : a.matchScore - b.matchScore;
    } else if (sortBy === 'deadline') {
      const dateA = new Date(a.deadline);
      const dateB = new Date(b.deadline);
      return sortDirection === 'desc' ? dateA - dateB : dateB - dateA;
    } else if (sortBy === 'duration') {
      const durationA = parseInt(a.duration.split(' ')[0]);
      const durationB = parseInt(b.duration.split(' ')[0]);
      return sortDirection === 'desc' ? durationB - durationA : durationA - durationB;
    } else if (sortBy === 'name') {
      return sortDirection === 'desc' ? b.name.localeCompare(a.name) : a.name.localeCompare(b.name);
    }
    return 0;
  });
  // Reset all filters
  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      degreeType: 'All Types',
      duration: 'All Durations',
      institution: 'All Institutions',
      tags: 'All Tags',
      matchLevel: 'All Matches'
    });
    setQuickFilter('All');
    setSortBy('relevance');
    setSortDirection('desc');
  };
  return <Layout persona="Student" data-id="element-4431">
      <div className="max-w-7xl mx-auto" data-id="element-4432">
        {/* Page Header */}
        <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-5 mb-6" data-id="element-4433">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-4434">
            <div className="mb-4 md:mb-0" data-id="element-4435">
              <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-4436">
                Explore Programs
              </h1>
              <p className="text-gray-600" data-id="element-4437">
                Find the perfect program that matches your interests and goals
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-4438">
              <button className="h-10 px-4 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors flex items-center justify-center" data-id="element-4439">
                <SearchIcon className="w-4 h-4 mr-2" data-id="element-4440" />
                Search Programs
              </button>
              <button className="h-10 px-4 bg-white text-primary-600 border border-primary-500 rounded-lg text-sm font-medium hover:bg-primary-50 transition-colors flex items-center justify-center" data-id="element-4441">
                <BrainIcon className="w-4 h-4 mr-2" data-id="element-4442" />
                Get AI Recommendations
              </button>
            </div>
          </div>
        </div>
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-4443">
          {/* Sidebar Filters - Desktop */}
          <div className="hidden lg:block" data-id="element-4444">
            <ProgramFilters filters={filters} setFilters={setFilters} data-id="element-4445" />
          </div>
          {/* Main Content Column */}
          <div className="lg:col-span-3 space-y-6" data-id="element-4446">
            {/* Recommended Programs */}

            {/* Search and Filters */}
            <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-5" data-id="element-4447">
              <div className="flex flex-col md:flex-row md:items-center gap-4 mb-4" data-id="element-4448">
                <div className="relative flex-grow" data-id="element-4449">
                  <input type="text" placeholder="Search programs by name, keyword, or institution..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4450" />
                  <SearchIcon className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" data-id="element-4451" />
                  {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600" data-id="element-4452">
                      <XIcon className="w-5 h-5" data-id="element-4453" />
                    </button>}
                </div>
                {/* Mobile Filter Button */}
                <div className="flex items-center space-x-3 lg:hidden" data-id="element-4454">
                  <button onClick={() => setShowMobileFilters(true)} className="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors flex items-center" data-id="element-4455">
                    <FilterIcon className="w-4 h-4 mr-2" data-id="element-4456" />
                    Filters
                  </button>
                </div>
                {/* View Toggle and Sort */}
                <div className="flex items-center space-x-3" data-id="element-4457">
                  <div className="flex border border-gray-200 rounded-lg" data-id="element-4458">
                    <button onClick={() => setView('card')} className={`p-2 ${view === 'card' ? 'bg-primary-50 text-primary-600' : 'text-gray-500 hover:text-gray-700'}`} title="Card View" data-id="element-4459">
                      <GridIcon className="w-5 h-5" data-id="element-4460" />
                    </button>
                    <button onClick={() => setView('table')} className={`p-2 ${view === 'table' ? 'bg-primary-50 text-primary-600' : 'text-gray-500 hover:text-gray-700'}`} title="Table View" data-id="element-4461">
                      <ListIcon className="w-5 h-5" data-id="element-4462" />
                    </button>
                  </div>
                  <div className="flex items-center" data-id="element-4463">
                    <select value={sortBy} onChange={handleSortChange} className="pl-3 pr-8 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-4464">
                      <option value="relevance" data-id="element-4465">Sort by: Relevance</option>
                      <option value="deadline" data-id="element-4466">Sort by: Deadline</option>
                      <option value="duration" data-id="element-4467">Sort by: Duration</option>
                      <option value="name" data-id="element-4468">Sort by: Name</option>
                    </select>
                    <button onClick={toggleSortDirection} className="ml-2 p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-4469">
                      {sortDirection === 'asc' ? <ArrowUpIcon className="w-4 h-4" data-id="element-4470" /> : <ArrowDownIcon className="w-4 h-4" data-id="element-4471" />}
                    </button>
                  </div>
                </div>
              </div>
              {/* Quick Filters */}
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-4472">
                <FilterChip label="All" isActive={quickFilter === 'All'} onClick={() => setQuickFilter('All')} data-id="element-4473" />
                <FilterChip label="Bachelor's" isActive={quickFilter === "Bachelor's"} onClick={() => setQuickFilter("Bachelor's")} data-id="element-4474" />
                <FilterChip label="Master's" isActive={quickFilter === "Master's"} onClick={() => setQuickFilter("Master's")} data-id="element-4475" />
                <FilterChip label="Doctorate" isActive={quickFilter === 'Doctorate'} onClick={() => setQuickFilter('Doctorate')} data-id="element-4476" />
                <FilterChip label="Diploma" isActive={quickFilter === 'Diploma'} onClick={() => setQuickFilter('Diploma')} data-id="element-4477" />
              </div>
              {/* Results Count */}
              <div className="text-sm text-gray-500 mb-4" data-id="element-4478">
                Showing {sortedPrograms.length} programs
                {(searchQuery || filters.degreeType !== 'All Types' || filters.duration !== 'All Durations' || filters.institution !== 'All Institutions' || filters.tags !== 'All Tags' || filters.matchLevel !== 'All Matches' || quickFilter !== 'All') && <button onClick={resetFilters} className="ml-2 text-primary-600 hover:underline" data-id="element-4479">
                    Clear filters
                  </button>}
              </div>
            </div>
            {/* Program List */}
            {sortedPrograms.length > 0 ? <div className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden" data-id="element-4480">
                {view === 'card' ? <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-4481">
                    {sortedPrograms.map(program => <ProgramCard key={program.id} program={program} onSave={toggleSaveProgram} isSaved={savedPrograms.includes(program.id)} data-id="element-4482" />)}
                  </div> : <div className="overflow-x-auto" data-id="element-4483">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-4484">
                      <thead className="bg-gray-50" data-id="element-4485">
                        <tr data-id="element-4486">
                          <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4487">
                            Program
                          </th>
                          <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4488">
                            Type/Duration
                          </th>
                          <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4489">
                            Location
                          </th>
                          <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4490">
                            Deadline
                          </th>
                          <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4491">
                            Match
                          </th>
                          <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4492">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-4493">
                        {sortedPrograms.map(program => <ProgramTableRow key={program.id} program={program} onSave={toggleSaveProgram} isSaved={savedPrograms.includes(program.id)} data-id="element-4494" />)}
                      </tbody>
                    </table>
                  </div>}
              </div> : <EmptyState onReset={resetFilters} onAiSuggestions={() => {
            // Handle AI suggestions
            resetFilters();
          }} data-id="element-4495" />}
          </div>
        </div>
      </div>
      {/* Mobile Filters Modal */}
      {showMobileFilters && <div className="fixed inset-0 z-50 overflow-hidden" data-id="element-4496">
          <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowMobileFilters(false)} data-id="element-4497"></div>
          <div className="absolute inset-y-0 right-0 max-w-full flex" data-id="element-4498">
            <div className="relative w-screen max-w-md" data-id="element-4499">
              <div className="h-full flex flex-col bg-white shadow-xl overflow-y-auto" data-id="element-4500">
                <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-4501">
                  <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-4502">
                    <FilterIcon className="w-5 h-5 mr-2" data-id="element-4503" />
                    Filters
                  </h2>
                  <button onClick={() => setShowMobileFilters(false)} className="text-gray-500 hover:text-gray-700 p-1" data-id="element-4504">
                    <XIcon className="w-6 h-6" data-id="element-4505" />
                  </button>
                </div>
                <div className="flex-1 overflow-y-auto" data-id="element-4506">
                  <ProgramFilters filters={filters} setFilters={setFilters} isOpen={true} onClose={() => setShowMobileFilters(false)} data-id="element-4507" />
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Mobile floating filter button */}
      <div className="lg:hidden fixed bottom-6 right-6 z-40" data-id="element-4508">
        <button onClick={() => setShowMobileFilters(true)} className="h-14 w-14 rounded-full bg-primary-500 text-white shadow-lg flex items-center justify-center hover:bg-primary-600 transition-colors" data-id="element-4509">
          <SlidersIcon className="h-6 w-6" data-id="element-4510" />
        </button>
      </div>
    </Layout>;
};
export default ExplorePrograms;